<template>
  <div :class="`main ${carts && carts.length > 0  ? 'show-cart' : 'hide-cart'}`" id="cart-bar">
    <div class="cart">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center text-secondary">
          <i class="fas fa-shopping-basket text-primary mr-2" style="font-size:20px;"></i>
          มีสินค้าในตะกร้าทั้งหมด <strong class="text-primary mx-1">{{ toatal.number }}</strong> รายการ
        </div>
        <div class="d-flex align-items-center cart-action">
          <small class="text-muted mr-2">รวมค่าสินค้า</small>
          <span class="cart-price text-primary font-weight-bold mr-3">฿{{ eArabic(toatal.price) }}</span>
          <button
            type="button"
            :class="['btn-cart', { 'non-active': toatal.number <= 0 }]"
            @click="cartPurchase()"
          >
            <i class="fas fa-shopping-cart mr-1"></i> สั่งซื้อสินค้า
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import  store  from "../store"
import { mapState } from 'vuex'
export default {
  data() {
    return {
      dataCarts: []
    }
  },
  mounted(){
    this.initDataCart()
  },
  methods: {
    cartPurchase() {
      store.commit('setFromBuyNow', false)
      $("#main-cid-detail").addClass("modal-open");
      $("#modal-purchase").removeClass("modal-purchase-hide");
      $("body").css({"overflow-y":"hidden"})
      $("#cart-bar").addClass("hide-cart");
      $("#cart-bar").removeClass("show-cart");
      store.commit('cartToPurchasing', this.dataCarts)
    },
    async initDataCart(){
      try{
        let hashProducts = {}

        for(let p of this.allProduct){
          hashProducts[p.id] = p
        }

        this.dataCarts = []

        if(localStorage.getItem('carts')){
          let localCarts = JSON.parse(localStorage.getItem('carts'))
          let balanceStore
          if(!this.hashBalanceProduct || this.hashBalanceProduct.length < 1){
            balanceStore = await this.Parse.Cloud.run("MarketProduct_countBalanceStores",{products: localCarts.map(item => {return item.productId})});
            store.commit('setHashBalanceProduct', balanceStore)
          }
          if(!this.carts)
            store.commit('setCarts', localCarts)

          for(let cart of this.carts){
            let obj = {
              number: cart.number,
              id: cart.productId,
              name : hashProducts[cart.productId].get('name'),
              image : hashProducts[cart.productId].get('images') ? this.$imgUrl(hashProducts[cart.productId].get('images')[0]) : "",
              fullPrice : hashProducts[cart.productId].get('fullPrice'),
              price: hashProducts[cart.productId].get('price'),
              isIncludeVat : hashProducts[cart.productId].get('isIncludeVat'),
              delivery : hashProducts[cart.productId].get('delivery') || 0,
              deliveryPerNumber : hashProducts[cart.productId].get('deliveryPerNumber') || 0,
              deliveryCategory : hashProducts[cart.productId].get('deliveryCategory'),
              productList : hashProducts[cart.productId].get('productList') || [] , 
              discount : hashProducts[cart.productId].get('discount') || {},
              balanceProduct: this.hashBalanceProduct[cart.productId].balanceProduct
            }
            this.dataCarts.push(obj)
          }
        }
      }catch(e){
        localStorage.removeItem('carts')
      }
    },
    updateCart(){

    },
    eArabic(x, num = 0) {
      if (x)
        return x.toLocaleString(undefined, {
          minimumFractionDigits: num,
          maximumFractionDigits: num
        });
      else return num == 2 ? "0.00" : "0";
    },
  },
  computed: {
    ...mapState([
      'purchasingProduct',
      'user',
      'allProduct',
      'carts',
      'hashBalanceProduct'
    ]),
    toatal() {
      let toatal = {
        number: 0,
        price: 0
      }
      if (this.dataCarts && this.dataCarts.length > 0) {
        for (let product of this.dataCarts) {
          toatal.number += product.number
          toatal.price += product.price * product.number
        }
      }
      return toatal
    }
  },
  watch: {
    allProduct(){
      this.initDataCart()
    },
    carts(){
      this.initDataCart()
    }
  },
};
</script>
<style scoped>
.main {
  position: fixed;
  bottom: 0;
  z-index: 2;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.06);
  width: 100%;
}
.cart {
  max-width: 1200px;
  margin: auto;
  padding: 12px 20px;
}
.cart-price {
  font-size: 22px;
}
.btn-cart {
  padding: 8px 24px;
  background: var(--primary);
  color: white;
  border: 2px solid var(--primary);
  border-radius: 24px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all .25s;
}
.btn-cart:hover {
  background: white;
  color: var(--primary);
}
.btn-cart:focus {
  outline: none;
}
.btn-cart.non-active {
  pointer-events: none;
  color: #bbb;
  border-color: #ddd;
  background: #f5f5f5;
}
.show-cart {
  display: block;
  opacity: 0;
  bottom: -20px;
  animation: show-cart .25s forwards;
}
.hide-cart {
  display: block;
  animation: hide-cart .25s forwards;
}
@keyframes show-cart {
  to { opacity: 1; bottom: 0; }
}
@keyframes hide-cart {
  to { opacity: 0; bottom: -20px; }
}
@media (max-width: 768px) {
  .cart-action {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }
  .btn-cart {
    width: 100%;
    text-align: center;
  }
}
</style>